module.exports = __webpack_public_path__ + "img/nav-applications.0a441103.svg";